<div id="assinar-desenho" [ngStyle]="{width:divWidth,heigth:divHeight}" class="assinatura-desenho">
    <button (click)="limparAssinatura()">Limpar assinatura</button>
    <canvas #canvasAssinarDesenho></canvas>
</div>
